class NovaVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.getInventoryData()
    this.getInventoryPolicy()
    this.updateOptionsInfo()
    this.addEventListener('change', this.onVariantChange)
    document.addEventListener('nova:cartData:updated', () => {
      this.getCartData()
    })
  }

  updateOptionsInfo() {
    this.updateOptions()
    this.updateMasterId()
    this._updateSwatchesBasedOnAvailability()
  }

  getCartData() {
    this.cartData = window.cartData
  }

  getInventoryData() {
    this.inventoryData = JSON.parse(
      this.querySelector('.variant-inventories[type="application/json"]')
        .textContent
    )
  }

  getInventoryPolicy() {
    this.inventoryPolicy = JSON.parse(
      this.querySelector('.variant-inventory-policies[type="application/json"]')
        .textContent
    )
  }

  onVariantChange(e) {
    this.updateOptionsInfo()
    this.updateMasterId()
    this.toggleQuantity(true, false)
    // this.updatePickupAvailability()
    this.resetSlider() // Reset the slider when a new variant is picked

    if (!this.currentVariant) {
      this.toggleQuantity(true, true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateMedia()

      // this.showVariantImages(e.target)
    }
  }

  resetSlider() {
    const slider = document.querySelector('.product-slider__main') // Replace with your slider's class or ID
    if (slider) {
      slider.scrollTo(0, 0) // Reset the slider to the initial position
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets?.length) {
      this.options = fieldsets.map((fieldset) => {

        const optionName = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).name;
        const selectedOption = Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
        this.querySelector(`[data-option="${optionName}"]`).innerHTML = selectedOption
        return selectedOption
      })
      this.optionFieldset = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).map(
          (radio) => radio.value
        )
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => {
          const selectedOption = select.value
          return selectedOption
        }
      )
      this.optionFieldset = Array.from(
        this.querySelectorAll('select'),
        (select) =>
          Array.from(select.querySelectorAll('option')).map(
            (option) => option.value
          )
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.options.every((option, index) => {
        return this.options[index] === option
      })
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    )

    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    for (const productForm of productForms) {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  updateAccordion(html) {
    const className = '.js-product-description-accordion'
    const destination = document.querySelector(className)
    const source = html.querySelector(className)
    if (source && destination) destination.innerHTML = source.innerHTML
  }

  updataPrice(html) {
    const id = `price-${this.dataset.section}`
    const destination = document.getElementById(id)
    const source = html.getElementById(id)
    if (source && destination) destination.innerHTML = source.innerHTML
  }

  reRenderProductProperties(html) {
    const propertiesSrc = html
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('.js-custom-properties') || ''

    const propertiesDst = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('.js-custom-properties')

    if (propertiesDst) {
      propertiesDst.innerHTML = propertiesSrc.innerHTML
    }
  }

  reRenderProductATC(html) {
    const atcSrc = html
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    const atcDst = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!atcDst || !atcSrc) return false

    const disabled = atcSrc.getAttribute('disabled')
    if (disabled) {
      atcDst.setAttribute('disabled', true)
    } else {
      atcDst.removeAttribute('disabled')
    }

    atcDst.innerHTML = atcSrc.innerHTML
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this.updataPrice(html)
        this.updateAccordion(html)

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')

        this.toggleQuantity(!this.currentVariant?.available)

        this.reRenderProductProperties(html)
        this.reRenderProductATC(html)
      })
  }

  toggleQuantity(disable = true, modifyClass = true) {
    const qtySelectorBuyButton = document.getElementById(
      'js-qty-selector-buy-buttons'
    )

    const qtyInput = qtySelectorBuyButton.querySelector('nova-quantity-input')

    if (!qtySelectorBuyButton) return

    if (disable) {
      qtySelectorBuyButton.classList.add('disabled')
    } else {
      qtySelectorBuyButton.classList.remove('disabled')
    }

    if (qtyInput) {
      this.variantQuantity = this.inventoryData[this.currentVariant?.id] || 0
      this.variantInventoryPolicy =
        this.inventoryPolicy[this.currentVariant?.id] || ''
      qtyInput.setAttribute('data-variant-id', this.currentVariant?.id || '')

      // If the variant has 'continue' quantity policy when 0 inventory, avoid assigning max quantity to it
      if (this.variantInventoryPolicy !== 'continue') {
        qtyInput.setAttribute('variant-max', this.variantQuantity)
        if (this.cartData) {
          const input = qtyInput.shadowRoot.querySelector('input')
          const cartAmount =
            this.cartData.find(
              (item) => item.variant_id === this.currentVariant?.id
            )?.quantity || 0
          if (
            Number(input.value) >
            Number(this.variantQuantity) - Number(cartAmount)
          ) {
            input.value =
              Number(this.variantQuantity) - Number(cartAmount) > 1
                ? Number(this.variantQuantity) - Number(cartAmount)
                : 1
            qtyInput.value = Number(input.value)
          }
        }
      }
    }

    if (this.cartData && this.currentVariant) {
      for (const item of this.cartData) {
        if (
          Number(item.variant_id) === Number(this.currentVariant.id) &&
          Number(this.variantQuantity) === Number(item.quantity)
        ) {
          qtySelectorBuyButton.classList.add('disabled')
        }
      }
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.querySelector('.product-variants[type="application/json"]')
          .textContent
      )
    return this.variantData
  }

  _updateSwatchesBasedOnAvailability() {
    const productVariants = this._getProductVariants()
    let unavailableOptions = []
    let loopedOptions = []

    if (this.options.length === 1) {
      unavailableOptions = productVariants
        .filter((variant) => !variant.available)
        .flatMap((variant) => variant.options)
    } else {
      this.options.forEach((currentOption, index) => {
        unavailableOptions = [
          ...unavailableOptions,
          ...this._getUnavailableOptions(
            productVariants,
            currentOption,
            index,
            this.optionFieldset[index],
            loopedOptions
          ),
        ]
        loopedOptions = [...loopedOptions, currentOption]
      })
    }

    this._updateSwatchClasses(unavailableOptions)
  }

  _getProductVariants() {
    return JSON.parse(this.querySelector('script.product-variants').innerHTML)
  }

  _getUnavailableOptions(
    productVariants,
    currentOption,
    index,
    optionFieldset,
    loopedOptions
  ) {
    if (!optionFieldset.includes(currentOption)) return

    const unavailableOptions = []
    for (const option of optionFieldset) {
      const existingVariants = productVariants.filter(
        (variant) =>
          variant.options[index] === option &&
          loopedOptions.every((options) => variant.options.includes(options))
      )

      const isUnavailableOption = existingVariants.some(
        (variant) => variant.available
      )

      if (!isUnavailableOption) {
        unavailableOptions.push(option)
      }
    }

    return unavailableOptions
  }

  _updateSwatchClasses(unavailableOptions) {
    const optionInputs = Array.from(this.querySelectorAll('fieldset input'))
    if (optionInputs?.length) {
      for (const input of optionInputs) {
        input.classList.remove('sold-out')
        if (unavailableOptions.includes(input.value)) {
          input.classList.add('sold-out')
        }
      }
    }
  }
}

customElements.define('nova-variant-picker', NovaVariantPicker)